// extracted by css-extract-rspack-plugin
module.exports =  {"completeButton":"TasksCard__completeButton___VY7WZ"};